import * as React from 'react';
export const IcFanAutoSpeed = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 7c0-3.16-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1c1 0 3-.84 3-4zm4 5h-6a1 1 0 00-1 1c0 1 .84 3 4 3s4-2 4-3a1 1 0 00-1-1zm-2.68-2a.51.51 0 00.68-.32l.22-.68h1.56l.25.68a.51.51 0 00.47.32h.18a.51.51 0 00.32-.68l-1.5-4a.52.52 0 00-.94 0l-1.5 4a.51.51 0 00.26.68zM19 6.92L19.4 8h-.8l.4-1.08zM11 13c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1zm0-2c0-1-.84-3-4-3s-4 2-4 3a1 1 0 001 1h6a1 1 0 001-1z'
      fill='currentColor'
    />
  </svg>
);
